<template>
  <div class="checkbox-main disable-selection" :style="{ cursor: isDisabled ? 'unset' : 'pointer' }" @click="click()" @keydown="keyDown">
    <div class="checkbox" ref="checkbox" :style="{ border: isDisabled ? '1px solid rgb(200,200,200)' : '1px solid black' }">
      <div class="check" :style="{ opacity: pIsChecked ? (isDisabled ? 0.6 : 1) : 0, color: checkColor, backgroundColor: checkBackground }">✔</div>
    </div>
    <div :style="{ opacity: isDisabled ? 0.5 : 1 }">{{ title }}</div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      pIsChecked: false
    }
  },
  props: {
    // Public properties
    isChecked: { type: Boolean, default: false }, // The state of the checkbox whether it is checked (true) or unchecked (false), use .sync for 2 way binding
    checkColor: { type: String, default: 'white' }, // Set the color of the tick icon
    checkBackground: { type: String, default: 'rgba(64,64,64,1)' }, // Set the color of the background of the check box
    title: { type: String, default: 'Check Box' }, // Set the title of the checkbox that will be displayed on the right of the check box
    isDisabled: { type: Boolean, default: false }, // Set to true if the check box is disabled

    // Public events
    // @checkBoxClicked - fired when the check box is clicked
  },
  methods: {
    click: function() {
      if (this.isDisabled) { 
        return;
      }

      if (this.pIsChecked) {
        this.pIsChecked = false;
      } else {
        this.pIsChecked = true;
      }

      this.$emit('update:isChecked', this.pIsChecked);
      this.$emit('checkBoxClicked');
    },
    keyDown: function(e) {
      if (e.keyCode == 32) {
        e.preventDefault();
        this.click();
      }
    }
  },
  mounted() {
    this.pIsChecked = this.isChecked;
  },
  watch: {
    isChecked: function(val) {
      this.pIsChecked = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.checkbox-main {
  display: flex;
  align-items: center;
  outline: none;
}

.checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 12px;
  width: 12px;
  min-width: 12px;
  border: 1px solid black;
  border-radius: 3px;
  margin-right: 5px;
  overflow: hidden;
}

.checkbox .check {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: $transition-time;
}
</style>